import {
  SET_OPEN_MODAL_TERCEIROS_INFORMATIVO,
  SET_OPEN_MODAL_TERCEIROS_VIDEO,
  SET_REDIRECT_TERCEIROS
} from "../actions/actionTypes";

const INITIAL_STATE = {
  openModalInformativo: false,
  openModalVideo: false,
  redirect: false
};

// eslintdisablenextline
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_OPEN_MODAL_TERCEIROS_INFORMATIVO:
      return {
        ...state,
        openModalInformativo: action.payload
      };
    case SET_OPEN_MODAL_TERCEIROS_VIDEO:
      return {
        ...state,
        openModalVideo: action.payload
      };
    case SET_REDIRECT_TERCEIROS:
      return {
        ...state,
        redirect: action.payload
      }
    default:
      return state;
  }
};